import { Feature } from "features/interfaces";
import { actions, reducer } from "./ducks";
import saga from "./saga";

export const unitsManagerFeature: Feature<typeof actions> = {
  reducer,
  saga,
  actions
};
